import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styles: []
})
export class ErrorComponent implements OnInit {
    constructor(
    ) { }

    ngOnInit() {
        if (document.getElementsByClassName("techbyte-header") && document.getElementsByClassName("techbyte-header").length > 0)
            document.getElementsByClassName("techbyte-header")[0].remove();
        if (document.getElementsByClassName("techbyte-sidebar") && document.getElementsByClassName("techbyte-sidebar").length > 0)
            document.getElementsByClassName("techbyte-sidebar")[0].remove();

        const isTechbyteAdmin = window.location.href.includes("/techbyte/admin")
        if (!isTechbyteAdmin)
            window.location.href = "/error";
        else if (!window.location.href.includes("/techbyte/admin/error"))
            window.location.href = "/techbyte/admin/error";
    }

    ngOnDestroy() {
        document.getElementById('page-loader').style.display = "block";
        window.location.reload();
    }

    onHome() {
        if (localStorage.getItem('logged')) {
            window.location.href = "/techbyte/admin"
        }
        else {
            window.location.href = "/techbyte/admin/login";
        }
    }
}